import { FC } from "react";
import { ISVG } from "types/ISVG";

const EspBtn: FC<ISVG> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="40" fill="none" viewBox="0 0 60 40">
      <g filter="url(#filter0_b_esp)">
        <rect width="59" height="39" x="0.5" y="0.51" stroke="#000" rx="12.5"></rect>
        <text x="30" y="25" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="600" fill="#000" textAnchor="middle">es</text>
      </g>
      <defs>
        <filter id="filter0_b_esp" width="145.515" height="125.515" x="-42.757" y="-42.747" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="21.379"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_esp"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_esp" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default EspBtn;

